import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Icon, IconName } from '@carbonify/ui';
import clsx from 'clsx';

import styles from './IconFeatureBlock.module.css';

interface IconFeatureBlockRecord extends CdaStructuredTextRecord {
  title?: string;
  subtitle?: string;
  icon?: { icon: IconName };
  theme?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  align?: 'top_left' | 'top_center' | 'top_text' | 'vertical_text';
}

export default function IconFeatureBlock({
  title,
  subtitle,
  icon,
  theme = 'primary',
  align = 'top_text',
}: IconFeatureBlockRecord) {
  return (
    <div className={clsx(styles.feature, styles[align])}>
      {icon && (
        <Icon
          name={icon}
          className={clsx(styles.icon, styles[theme])}
        />
      )}
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {subtitle}
      </div>
    </div>
  );
}
